/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetOrganizationsQueryResponse,
  GetOrganizations401,
} from "../types/GetOrganizations.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOrganizationsQueryKey = () =>
  [{ url: "/organizations" }] as const;

export type GetOrganizationsQueryKey = ReturnType<
  typeof getOrganizationsQueryKey
>;

/**
 * @summary Получение организаций текущего пользователя
 * {@link /organizations}
 */
export async function getOrganizations(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetOrganizationsQueryResponse,
    ResponseErrorConfig<GetOrganizations401>,
    unknown
  >({ method: "GET", url: `/organizations`, ...requestConfig });
  return res;
}

export function getOrganizationsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getOrganizationsQueryKey();
  return queryOptions<
    ResponseConfig<GetOrganizationsQueryResponse>,
    ResponseErrorConfig<GetOrganizations401>,
    ResponseConfig<GetOrganizationsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getOrganizations({ ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * @summary Получение организаций текущего пользователя
 * {@link /organizations}
 */
export function useGetOrganizations<
  TData = ResponseConfig<GetOrganizationsQueryResponse>,
  TQueryData = ResponseConfig<GetOrganizationsQueryResponse>,
  TQueryKey extends QueryKey = GetOrganizationsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetOrganizationsQueryResponse>,
        ResponseErrorConfig<GetOrganizations401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getOrganizationsQueryKey();

  const query = useQuery(
    {
      ...getOrganizationsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetOrganizations401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
